import _ from "lodash";
import getContentById from "../utils/getContentById";

export const getScorersOverride = (fields) => {
  const homeScorers = [];
  const awayScorers = [];
  _.times(10, (index) => {
    let indexHome = _.clone(index);
    let indexAway = _.clone(index);
    const homeValue = getContentById(`homeScorer${++indexHome}`, fields);
    const awayValue = getContentById(`awayScorer${++indexAway}`, fields);

    if (homeValue) {
      homeScorers.push(homeValue);
    } else {
      homeScorers.push(null);
    }

    if (awayValue) {
      awayScorers.push(awayValue);
    } else {
      awayScorers.push(null);
    }
  });

  return {
    homeScorers,
    awayScorers,
  };
};
